<template>
  <div style="background-color: #F8F9FB;text-align: center;">
    <hhead></hhead>
    <div class="newsBox">
      <div class="newsList" :style="{ minHeight: MHeight }">
        <div style="width: 560px;margin: 0 auto;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="本月排行" name="month">
              <div
                class="weekList"
                @click="pushDetail(item.id, item.serverId)"
                v-for="(item, index) in RankingList.thisMonthProfit"
                :key="index"
              >
                <div
                  class="left"
                  style="display: flex;flex: 1;text-align: left;"
                >
                  <div class="no">
                    <img
                      v-if="index < 5"
                      :src="
                        require('../../../assets/images/crm/no' +
                          (index + 1) +
                          '.png')
                      "
                      alt=""
                    />
                    <span
                      style="color: #868e99;width: 34px ;text-align: center;display: block;"
                      v-if="index >= 5"
                    >
                      {{ (index + 1) | numnum }}
                    </span>
                  </div>
                  <div style="text-align: center;">
                    <p
                      style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size:14px;"
                    >
                      {{ item.userName }}
                    </p>
                    <p
                      style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color: #868e99;"
                    >
                      {{ item.userCode }}
                    </p>
                  </div>
                </div>
                <div style="flex: 0.5;text-align: center;font-size: 14px;">
                  {{ item.simpleName }}
                </div>
                <div style="flex: 1;text-align: right;">
                  <p style="white-space: nowrap;">
                    累计收益：<span
                      :style="{
                        color:
                          item.thisMonthProfit >= 0 ? '#FA5D22' : '#3ABA94',
                        fontSize: '20px',
                      }"
                    >
                      {{ item.thisMonthProfit | num }}</span
                    >
                    <i
                      style="color: #FA5D22;"
                      class="el-icon-top"
                      v-if="item.profitRateAdd > 0"
                    ></i
                    ><i
                      v-if="item.profitRateAdd < 0"
                      style="color:#3ABA94"
                      class="el-icon-bottom"
                    ></i>
                  </p>

                  <span
                    :style="{
                      color: item.profitRateAdd >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '12px',
                    }"
                    >{{ item.profitRateAdd | num }}</span
                  >
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="本年排行" name="year">
              <div
                class="weekList"
                @click="pushDetail(item.id, item.serverId)"
                v-for="(item, index) in RankingList.thisYearlyProfit"
                :key="index"
              >
                <div class="left" style="display: flex;flex: 1;">
                  <div class="no">
                    <img
                      v-if="index < 5"
                      :src="
                        require('../../../assets/images/crm/no' +
                          (index + 1) +
                          '.png')
                      "
                      alt=""
                    />
                    <span
                      style="color: #868e99;width: 34px ;text-align: center;display: block;"
                      v-if="index >= 5"
                    >
                      {{ (index + 1) | numnum }}
                    </span>
                  </div>
                  <div style="text-align: center;">
                    <p
                      style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;"
                    >
                      {{ item.userName }}
                    </p>
                    <p
                      style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color:#868e99 ;"
                    >
                      {{ item.userCode }}
                    </p>
                  </div>
                </div>
                <div style="flex: 0.5;text-align: center;font-size: 14px;">
                  {{ item.simpleName }}
                </div>
                <div style="flex: 1;text-align: right;">
                  <p style="white-space: nowrap;">
                    累计收益：<span
                      :style="{
                        color: item.thisYearProfit >= 0 ? '#FA5D22' : '#3ABA94',
                        fontSize: '20px',
                      }"
                    >
                      {{ item.thisYearProfit | num }}</span
                    >
                    <i
                      style="color: #FA5D22;"
                      class="el-icon-top"
                      v-if="item.profitRateAdd > 0"
                    ></i
                    ><i
                      v-if="item.profitRateAdd < 0"
                      style="color:#3ABA94"
                      class="el-icon-bottom"
                    ></i>
                  </p>

                  <span
                    :style="{
                      color: item.profitRateAdd >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '12px',
                    }"
                    >{{ item.profitRateAdd | num }}</span
                  >
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="净值排行" name="netWorth">
              <div
                class="weekList"
                @click="pushDetail(item.id, item.serverId)"
                v-for="(item, index) in RankingList.sumNet"
                :key="index"
              >
                <div class="left" style="display: flex;flex: 1;">
                  <div class="no">
                    <img
                      v-if="index < 5"
                      :src="
                        require('../../../assets/images/crm/no' +
                          (index + 1) +
                          '.png')
                      "
                      alt=""
                    />
                    <span
                      style="color: #868e99;width: 34px ;text-align: center;display: block;"
                      v-if="index >= 5"
                    >
                      {{ (index + 1) | numnum }}
                    </span>
                  </div>
                  <div>
                    <p
                      style="text-align: center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;"
                    >
                      {{ item.userName }}
                    </p>
                    <p
                      style="text-align: center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color:#868e99 ;"
                    >
                      {{ item.userCode }}
                    </p>
                  </div>
                </div>
                <div style="flex: 0.51;text-align: center;font-size: 14px;">
                  {{ item.simpleName }}
                </div>
                <div style="flex: 1;">
                  <p style="text-align: right;">
                    净值：<span
                      :style="{
                        color: item.sumNet >= 1 ? '#FA5D22' : '#3ABA94',
                      }"
                      >{{ item.sumNet | num2 }}</span
                    >
                  </p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="回撤排行" name="hc">
              <div
                class="weekList"
                @click="pushDetail(item.id, item.serverId)"
                v-for="(item, index) in RankingList.maxLoss"
                :key="index"
              >
                <div class="left" style="display: flex;flex: 1;">
                  <div class="no">
                    <img
                      v-if="index < 5"
                      :src="
                        require('../../../assets/images/crm/no' +
                          (index + 1) +
                          '.png')
                      "
                      alt=""
                    />
                    <span
                      style="color: #868e99;width: 34px ;text-align: center;display: block;"
                      v-if="index >= 5"
                    >
                      {{ (index + 1) | numnum }}
                    </span>
                  </div>
                  <div>
                    <p
                      style="text-align:center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;"
                    >
                      {{ item.userName }}
                    </p>
                    <p
                      style="text-align:center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color:#868e99 ;"
                    >
                      {{ item.userCode }}
                    </p>
                  </div>
                </div>
                <div style="flex: 0.5;text-align:center;font-size: 14px;">
                  {{ item.simpleName }}
                </div>
                <div style="flex: 1;">
                  <p style="text-align: right;">
                    最近回撤：<span
                      :style="{
                        color: item.maxLoss >= 0 ? '#FA5D22' : '#3ABA94',
                      }"
                      >{{ item.lastLoss | num }}</span
                    >
                  </p>
                </div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="最优策略" name="strategy">
              <div
                class="weekList"
                v-for="(item, index) in RankingList.strategy"
                :key="index"
              >
                <div class="left" style="display: flex;flex: 1;">
                  <div class="no">
                    <img
                      v-if="index < 5"
                      :src="
                        require('../../../assets/images/crm/no' +
                          (index + 1) +
                          '.png')
                      "
                      alt=""
                    />
                  </div>
                  <div style="text-align: center;">
                    <p
                      style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ item.simpleName }}
                    </p>
                  </div>
                </div>
                <div style="flex: 0.5;font-size: 14px;text-align: center;">
                  账户数量
                  <p>{{ item.invNum }}</p>
                </div>

                <div style="flex:1;text-align: right;">
                  <p style="white-space: nowrap;">
                    累计收益：
                    <span
                      :style="{
                        color: item.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        fontSize: '20px',
                      }"
                    >
                      {{ item.profitRate | num }}</span
                    >
                    <i
                      style="color: #FA5D22;"
                      class="el-icon-top"
                      v-if="item.profitRateAdd > 0"
                    ></i
                    ><i
                      v-if="item.profitRateAdd < 0"
                      style="color:#3ABA94"
                      class="el-icon-bottom"
                    ></i>
                  </p>

                  <span
                    :style="{
                      color: item.profitRateAdd >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '12px',
                    }"
                    >{{ item.profitRateAdd | num }}</span
                  >
                </div>
              </div>
            </el-tab-pane> -->
            <el-tab-pane label="最优合作方" name="mechanism">
              <div
                class="weekList"
                v-for="(item, index) in RankingList.BestInvestor"
                :key="index"
                @click="pushDetail_(item.id)"
              >
                <div class="left" style="display: flex;flex: 1;">
                  <div class="no">
                    <img
                      v-if="index < 5"
                      :src="
                        require('../../../assets/images/crm/no' +
                          (index + 1) +
                          '.png')
                      "
                      alt=""
                    />
                    <span
                      style="color: #868e99;width: 34px ;text-align: center;display: block;"
                      v-if="index >= 5"
                    >
                      {{ (index + 1) | numnum }}
                    </span>
                  </div>
                  <div style="text-align: center;">
                    <p
                      style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ item.simpleName }}
                    </p>
                  </div>
                </div>
                <div style="flex:0.5;text-align: center;font-size: 14px;">
                  账户数量
                  <p>{{ item.accCount }}</p>
                </div>

                <div style="flex: 1;text-align: right;">
                  <p style="white-space: nowrap;">
                    累计收益：
                    <span
                      :style="{
                        color: item.sumProfit >= 0 ? '#FA5D22' : '#3ABA94',
                        fontSize: '20px',
                      }"
                    >
                      {{ item.sumProfit | num }}</span
                    >
                  </p>
                  <span>&nbsp;</span>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- <div class="page_box">
            <div class="msg_count">
              共&nbsp;{{ length ? length : '0' }}&nbsp;条
            </div>
            <div class="blank"></div>
            <div class="page">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pageLength ? pageLength : 0"
                @current-change="currentPage"
              >
              </el-pagination>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../header/index';
import './style.css';
export default {
  components: { hhead },
  data() {
    return {
      pageLength: null,
      length: '',
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      activeName: '',
      RankingList: '',
      jurisdiction: [], //权限
    };
  },
  filters: {
    //收益格式化
    //收益格式化
    num: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else {
        return '0.00%';
      }
    },
    num1: function(n) {
      if (n) {
        return Math.round(n * 10000) / 100;
      } else {
        return 0;
      }
    },
    //净值
    num2: function(n) {
      if (n) {
        return n.toFixed(4);
      } else {
        return 0;
      }
    },
    num3: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2);
      } else {
        return 0;
      }
    },
    numnum: function(e) {
      if (e < 10) {
        return '0' + e;
      } else {
        return e;
      }
    },
  },
  mounted() {
    this.$axios
      .post('/crm/ent/getAuthInfo', {
        apiToken: this.$store.state.usermsg.apiToken,
      })
      .then((res) => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200 || res.data.code == 403) {
          this.res = res.data.data;
        } else if (res.data.code == 400) {
          this.$router.push('/crm/qyQuery');
        } else if (res.data.code == 401) {
          this.$router.push('/crm/qyQuery/state');
        }
      });

    this.$axios
      .post('/crm/mem/queryAllModel', {
        apiToken: this.$store.state.usermsg.apiToken,
        customerId: this.$store.state.usermsg.id,
      })
      .then((res) => {
        // // console.log(res);
        if (res.data.code == 200) {
          this.jurisdiction = res.data.data.model;
        }
      });

    if (this.$route.query.type) {
      this.activeName = this.$route.query.type;
    } else {
      this.activeName = 'month';
    }
    this.$axios
      .post('/crm/ent/getLeaderboard', {
        apiToken: this.$store.state.usermsg.apiToken,
        size: 1000,
      })
      .then((res) => {
        // // console.log(res);
        if (res.data.code == 200) {
          this.RankingList = res.data.data;
        }
      });
  },
  methods: {
    currentPage(e) {
      //当前页
      this.page = e;
    },
    handleClick(e) {
      // // console.log(e.name);
      //   if (e.name == 'month') {
      //     this.length = this.RankingList.thisMonthProfit.length;
      //     this.pageLength = Math.ceil(
      //       this.RankingList.thisMonthProfit.length / 1.5
      //     );
      //   }
      //   if (e.name == 'year') {
      //     this.length = this.RankingList.thisYearlyProfit.length;
      //     this.pageLength = Math.ceil(
      //       this.RankingList.thisYearlyProfit.length / 1.5
      //     );
      //   }
      //   if (e.name == 'netWorth') {
      //     this.length = this.RankingList.sumNet.length;
      //     this.pageLength = Math.ceil(this.RankingList.sumNet.length / 1.5);
      //   }
      //   if (e.name == 'hc') {
      //     this.length = this.RankingList.maxLoss.length;
      //     this.pageLength = Math.ceil(this.RankingList.maxLoss.length / 1.5);
      //   }
      //   if (e.name == 'strategy') {
      //     this.length = this.RankingList.strategy.length;
      //     this.pageLength = Math.ceil(this.RankingList.strategy.length / 1.5);
      //   }
      //   if (e.name == 'mechanism') {
      //     this.length = this.RankingList.BestInvestor.length;
      //     this.pageLength = Math.ceil(this.RankingList.BestInvestor.length / 1.5);
      //   }
    },
    pushDetail(id, serverId) {
      //查看详情
      // // console.log(this.jurisdiction[4].selected);
      if (this.jurisdiction[4].selected) {
        //账户管理权限为true

        this.$router.push(`/crm/user/uDetails?id=${id}&serverId=${serverId}`);
      } else {
        this.$alert('当前用户暂无权限', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    pushDetail_(id) {
      //投顾详情
      if (this.jurisdiction[2].selected) {
        //投顾管理权限为true

        this.$router.push(`/crm/InvestorManage/details?id=${id}`);
      } else {
        this.$alert('当前用户暂无权限', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/view/crm/Ranking/index.vue